let pageGlobal = document.getElementById("pageGlobal");
const reference = document.getElementById("pageGlobal");

/*           
function initDemoBlocks() {
  const template = document.getElementById('demo-template');

  document.querySelectorAll('div[id^="demo"]').forEach((div) => {
    const idMatch = div.id.match(/^demo(\d+)$/);
    if (!idMatch) return;

    const demoId = idMatch[1];
    const clone = template.content.cloneNode(true);
    const link = `/global/${demoId}/`;

    clone.querySelector('.demo-image').src = link + 'prevImage.webp';
    
    clone.querySelector('.image1').src = link + '1.webp';
    clone.querySelector('.image2').src = link + '2.webp';
    clone.querySelector('.image3').src = link + '3.webp';
    clone.querySelector('.image4').src = link + '4.webp';

    // Ajout du clone au DOM **avant** fetch
    div.appendChild(clone);

    fetch(link + 'content.json')
      .then(res => {
        if (!res.ok) throw new Error('Erreur HTTP ' + res.status);
        return res.json();
      })
      .then(data => {
        const txtEl = div.querySelector('.demo-txt');
        const titreEl = div.querySelector('.titre');
        if (titreEl) titreEl.textContent = data.titre;
        if (txtEl) txtEl.textContent = data.titre;
        
        const highlightNumbers = (text) => {
          return text.replace(/(\d[\d\s\.,eE\+\-]*)/g, '<span style="font-family: Arial, sans-serif;">$1</span>');
        };

        const p1El = div.querySelector('.p1');
        if (p1El) p1El.innerHTML = highlightNumbers(data.p1);

        const p2El = div.querySelector('.p2');
        if (p2El) p2El.innerHTML = highlightNumbers(data.p2);

        const p3El = div.querySelector('.p3');
        if (p3El) p3El.innerHTML = highlightNumbers(data.p3);

        const p4El = div.querySelector('.p4');
        if (p4El) p4El.innerHTML = highlightNumbers(data.p4);

        const carousel = document.querySelectorAll('.carousel');
        if (data.nbCode <= 0) {
          carousel[demoId-1].style.display = 'none';
        }
        for (let i = 1; i <= data.nbCode; i++) {
          
          const img = document.createElement('img');
          img.src = link +'code/'+ i +'.webp';
          img.alt = 'image code' + i;
          img.classList.add('imageCarrousel');
          img.id = demoId + 'img' + i;
          carousel[demoId-1].appendChild(img);

          const txt = document.createElement('p');
          txt.textContent = data.codeIndice[i-1];
          txt.classList.add('carouselText');
          txt.id = demoId + 'txt' + i;
          txt.style.opacity = 0;
          txt.style.transform = "translateX(-50px)";
          carousel[demoId-1].appendChild(txt);

          document.getElementById(demoId + 'img1' ).style.zIndex = 2;
          document.getElementById(demoId + 'img1' ).style.maxHeight = "none";
          document.getElementById(demoId + 'txt1' ).style.opacity = 1;
          document.getElementById(demoId + 'txt1' ).style.transform = "translateX(0px)";
          
          document.getElementById(demoId + 'img' + i).addEventListener('click', () => {
            
            //carousel[demoId-1].scrollTop = 0;
            const images = carousel[demoId-1].querySelectorAll('img');
            const texts = carousel[demoId-1].querySelectorAll('p');
            images[i-1].style.zIndex = 1;
            let nextIndex = i % data.nbCode + 1;
            images[nextIndex - 1].style.zIndex = 2;

            texts[i - 1].style.opacity = 0;
            texts[i - 1].style.transform = "translateX(-50px)";
            

            texts[nextIndex - 1].style.opacity = 1;
            texts[nextIndex - 1].style.transform = "translateX(0px)";
            images[nextIndex - 1].style.maxHeight = "none";


            gsap.fromTo(document.getElementById(demoId + 'img' + nextIndex), {
              opacity: 0,
            }, {
              opacity: 1,
              duration: 0.4,
              ease: "easeInOut",
              onComplete: () => {
                images[i - 1].style.maxHeight = "400px";
                document.getElementById(demoId + 'img' + i).style.zIndex = 0;
              }
            });
          });
        }
        
        const skills = document.querySelectorAll('.competences');
        for (let i = 1; i <= data.nbSkills; i++) {
          const txt = document.createElement('p');
          txt.textContent = data.skills[i-1];
          txt.classList.add('skillText');
          skills[demoId-1].appendChild(txt);
        }

      })
      .catch(err => {
        console.error('Erreur fetch content.json:', err);
      });

  });
}
*/

//initDemoBlocks();

/*
pageGlobal.addEventListener('click', (event) => {
    const carte = event.target.closest('[id^="demo"]');
    if (carte) {
        
        scale(carte.id);
    } else {
        
    }
});


function scale(demoId){
    
  const demo = document.getElementById(demoId);
  const upscaleDiv = demo.querySelector('.upscale');
  
  // Vérifie si l'élément existe avant d'essayer de le modifier
  if (upscaleDiv.style.display == "flex") {
      //upscaleDiv.style.display = "none";
  }else{
      upscaleDiv.style.display = "flex";
  }





  const mask = document.getElementById("clickMask");
  
  // Supprimer anciens cercles si tu veux un effet propre à chaque clic :
  mask.querySelectorAll("circle").forEach(c => c.remove());

  const rect = document.body.getBoundingClientRect();
  const mouseX = event.clientX;
  const mouseY = event.clientY;

  const r = "100vw";

  const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
  circle.setAttribute("cx", mouseX);
  circle.setAttribute("cy", mouseY);
  circle.setAttribute("r", 0);
  circle.setAttribute("fill", "white");
  mask.appendChild(circle);

  // Animation d’apparition
  circle.animate(
    [
      { r: 0 ,
      },
      { r: r,
      }
    ],
    {
      duration: 1000,
      easing: "ease-out",
      fill: "forwards"
    }
  );


  
}
*/







gsap.set(pageGlobal, {opacity: 0});

let timeout;

function pageGlobalStart() {
    clearTimeout(timeout);

    pageGlobal.style.display = "flex";
    gsap.to(pageGlobal, {
            opacity: 1,
            duration: 1,
            ease: "power2.Out"
        });

    
    gsap.fromTo("#demo1", 
      { x: 800 }, 
      { x: 0, duration: 1, ease: "expo.out" }
    );
    gsap.fromTo("#demo2", 
      { x: 800 }, 
      { x: 0, duration: 1.3, ease: "expo.out" }
    );
    gsap.fromTo("#demo3", 
      { x: 800 }, 
      { x: 0, duration: 1.6, ease: "expo.out" }
    );
    gsap.fromTo("#demo4", 
      { x: 800 }, 
      { x: 0, duration: 1.9, ease: "expo.out" }
    );
    gsap.fromTo("#comSoon", 
      { x: 800 }, 
      { x: 0, duration: 2.2, ease: "expo.out" }
    );
    gsap.fromTo("#live2dCanvas", 
      { x: "-55%" }, 
      { x: "-40%", duration: 2.2, ease: "expo.out" }
    );

  }


function pageGlobalEnd() {
    
    gsap.to(pageGlobal, {
            opacity: 0,
            duration: 1,
            ease: "power2.Out"
        });

    timeout = setTimeout(() => {
      pageGlobal.style.display = "none";
    }, 1000);
        
}

pageGlobal.style.display = "none";
window.pageGlobalStart = pageGlobalStart;
window.pageGlobalEnd = pageGlobalEnd;


const backB = document.getElementById("retourMenu");
const elements = document.querySelectorAll(".demo");
const projet = document.getElementById("projet");



elements.forEach(element => {
  element.addEventListener("mouseenter", () => {
    gsap.to(element, { scale: 1.05, duration: 0.3, ease: "power2.out" });
  });

  element.addEventListener("mouseleave", () => {
    gsap.to(element, { scale: 1, duration: 0.3, ease: "power2.out" });
  });

  element.addEventListener('click', (event) => {
    
    elements.forEach(el => {
      if (el !== element){
        el.style.zIndex = 0;
      }
    });
    element.style.zIndex = 5;
    projetReveal();
    projetSetup(element.id);
  });
});

let stopCoroutine = false;
function projetReveal(){
  stopCoroutine = false;
  gsap.killTweensOf(backB);
  gsap.killTweensOf(projet);
  gsap.killTweensOf("#projetBG");
  gsap.to(projet, { x: "0vw", duration: 0});
  gsap.to("#projetBG", { x: "0vw", duration: 0});
  projet.style.zIndex = 10;
  gsap.to(backB, { x: "13vw", duration: 0.6, ease: "power2.inout" });

  const mask = document.getElementById("clickMask");
  const _svg = document.getElementById("_svg");
  
  // Supprimer anciens cercles si tu veux un effet propre à chaque clic :
  mask.querySelectorAll("circle").forEach(c => c.remove());
  _svg.querySelectorAll("circle").forEach(c => c.remove());

  const rect = projet.getBoundingClientRect();
  const mouseX = event.clientX;
  const mouseY = event.clientY;

  maCoroutine(false);
  maCoroutine(true);

  async function maCoroutine(maskON) {
    
    const circle1 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    circle1.setAttribute("cx", mouseX - rect.left);
    circle1.setAttribute("cy", mouseY);
    circle1.setAttribute("r", 0);
    circle1.setAttribute("fill", "white");
    if(!maskON) circle1.setAttribute("filter", "url(#blurFilter)")
    if(maskON) mask.appendChild(circle1);
    else _svg.appendChild(circle1);

    const centerX = mouseX - rect.left;

    const centerY = mouseY;

    await new Promise(resolve => setTimeout(resolve, 50));

    const step = 40; // distance angulaire entre chaque point (en radians)
    const radiusStep = (window.innerWidth / 500) // à quel point le rayon s’élargit à chaque itération

    for (let i = 0; i < 99; i++) {
      if (stopCoroutine){ 
        return;
      } 
      await new Promise(resolve => setTimeout(resolve, 30-i/5));
      
      const angle = step * i ** (1 / 2); // angle en radians
      const radius = radiusStep * i ** (1.35); // rayon en pixels
      circle1.setAttribute("r", radius/1.2);
      const posX = centerX + Math.cos(angle) * radius;
      const posY = centerY + Math.sin(angle) * radius;

      const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
      circle.setAttribute("cx", posX);
      circle.setAttribute("cy", posY);
      circle.setAttribute("r", 0);
      circle.setAttribute("fill", "white");
      if(!maskON) circle.setAttribute("filter", "url(#blurFilter)")
      if(maskON) mask.appendChild(circle);
      else _svg.appendChild(circle);

      circleAnimate(circle, 2+i/5+"vw", 200);
    }

    
  }

  function circleAnimate(circle, r, temps){
    circle.animate(
      [
        { r: 0},
        { r: r,}
      ],
      {
        duration: temps,
        easing: "ease-out",
        fill: "forwards"
      }
    );
  };
}

//
function projetClose(){
  gsap.to(backB, { x: "0vw", duration: 0.9, ease: "power2.inout" });
  gsap.to(projet, { x: "100vw", duration: 0.9, ease: "power2.inout" });
  gsap.to("#projetBG", { x: "100vw", duration: 0.9, ease: "power5.inout" });
  stopCoroutine = true;
  
  projet.style.zIndex = 8;
  textBulle.style.opacity = 0;
}

window.projetClose = projetClose;


const textBulle = document.getElementById("text");
textBulle.addEventListener('click', () => {
  textBulle.style.opacity = 0;
  showIntro();
});

textBulle.style.opacity = 0;

const nbProjet = 3;
let projets = [];
for (let i = 1; i <= nbProjet; i++) {
  projets[i] = document.getElementById("projet" + i);
}

const IntroP2 = document.getElementById("IntroP2");
const IntroP1 = document.getElementById("IntroP1");
function showIntro(){
  IntroP1.style.opacity = 1;
  IntroP2.style.opacity = 1;
}
function hideIntro(){
  IntroP1.style.opacity = 0;
  IntroP2.style.opacity = 0;
}

function projetSetup(_id){
  hideIntro();
  const id = _id.match(/\d+/)[0];

  projets.forEach((projet, index) => {
    if (index == id) {
      projet.style.display = "flex";
    } else {
      projet.style.display = "none";
    }
  });
  projet.scrollTop = 0;

  const demoId = _id;

  const link = `/global/${demoId}/`;

  let titre = ""
  let p1 =    ""
  let p2 =    ""
  let p3 =    ""
  let p4 =    ""

  fetch(link + 'content.json')
    .then(res => {
      if (!res.ok) throw new Error('Erreur HTTP ' + res.status);
      return res.json();
    })
    .then(data => {
      titre = data.titre;
      p1 = data.p1;
      p2 = data.p2;
      p3 = data.p3;
      p4 = data.p4;
    

    lireTexte(p1);

    })
    .catch(err => {
      console.error('Erreur fetch content.json:', err);
  });

  function lireTexte(p){
    textBulle.style.opacity = 1;
    textBulle.style.height = "auto";

    const oldHeight = textBulle.offsetHeight;
    textBulle.innerHTML = p;
    const newHeight = textBulle.scrollHeight;

    gsap.fromTo(textBulle, 
      { height: oldHeight }, 
      { height: newHeight, duration: 0.5, ease: "cubic-bezier(0,1,0,1)" }
    );

    animateText("text", 25, 0, false, 1, true);
  }

  IntroP1.addEventListener('click', () => { lireTexte(p1); });

  const figmaSF_ESP = document.getElementById("figmaSF_ESP");
  figmaSF_ESP.addEventListener('click', () => { lireTexte(p2); showIntro(); });

  const wpSF_ESP = document.getElementById("wpSF_ESP");
  wpSF_ESP.addEventListener('click', () => { lireTexte(p3); showIntro(); });
  
  const bddSF_ESP = document.getElementById("bddSF_ESP");
  bddSF_ESP.addEventListener('click', () => { lireTexte(p4); showIntro(); });

  IntroP2.addEventListener('click', () => { lireTexte(p1); });

  const unityUT_ESP = document.getElementById("unityUT_ESP");
  unityUT_ESP.addEventListener('click', () => { lireTexte(p2); showIntro(); });

  const shaderUT_ESP = document.getElementById("shaderUT_ESP");
  shaderUT_ESP.addEventListener('click', () => { lireTexte(p3); showIntro(); });


  
}

